import './Banner-c1744c4b.css';

var classes = {"Banner":"prc-Banner-Banner-IR8eJ","BannerContainer":"prc-Banner-BannerContainer-lbx3d","BannerActions":"prc-Banner-BannerActions-XCfHL","BannerContent":"prc-Banner-BannerContent-zTITK","BannerTitle":"prc-Banner-BannerTitle-TcuJl","BannerIcon":"prc-Banner-BannerIcon-WuOyf","BannerDismiss":"prc-Banner-BannerDismiss-uBZVm","BannerActionsContainer":"prc-Banner-BannerActionsContainer-ukGMH"};

export { classes as default };
